"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockUSDManagerInitializer = void 0;
/* eslint-disable no-console */
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const mockUsdManager_1 = require("./mockUsdManager");
const USD_ERROR = 'Mock USD initialization error';
const CHANNEL_CC = 'CC';
const PLATFORM_DESKTOP = 'DESKTOP';
class MockUSDManagerInitializationError extends web_ui_framework_1.InitializerError {
    constructor(errorMessage, channel, platform) {
        const message = `[Channel: ${channel}. Platform: ${platform}] ${errorMessage}`;
        super(USD_ERROR, message);
    }
}
class MockUSDManagerInitializer extends web_ui_framework_1.Initializer {
    constructor() {
        super();
        this.launch = () => {
            try {
                return new mockUsdManager_1.MockUSDManager();
            }
            catch (e) {
                throw new MockUSDManagerInitializationError(e, CHANNEL_CC, PLATFORM_DESKTOP);
            }
        };
    }
}
exports.MockUSDManagerInitializer = MockUSDManagerInitializer;
//# sourceMappingURL=mockUsd.initializer.js.map